export default "__VITE_ASSET__7f6ed4de__"